import { render, staticRenderFns } from "./OTags.vue?vue&type=template&id=2828018a&scoped=true"
import script from "./OTags.vue?vue&type=script&lang=js"
export * from "./OTags.vue?vue&type=script&lang=js"
import style0 from "./OTags.vue?vue&type=style&index=0&id=2828018a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2828018a",
  null
  
)

export default component.exports